import { useState, useEffect } from "react";
import { Dialog, DialogHeader } from "@astryxdesign/core/Dialog";
import { Stack, HStack } from "@astryxdesign/core/Stack";
import { Text } from "@astryxdesign/core/Text";
import { Banner } from "@astryxdesign/core/Banner";
import { Button } from "@astryxdesign/core/Button";
import { ProgressBar } from "@astryxdesign/core/ProgressBar";

export default function DownloadProgressModal({
  isOpen,
  onClose,
  folderName,
  isDownloading,
  progress = 0,
  currentFile = "",
  error = null,
  onCancel,
}) {
  const [isCancelling, setIsCancelling] = useState(false);

  useEffect(() => {
    // Reset state when modal opens
    if (isOpen) {
      setIsCancelling(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCancel = () => {
    setIsCancelling(true);
    if (onCancel) {
      onCancel();
    }
  };

  const title = error
    ? "Erro no Download"
    : isDownloading
      ? "Baixando Pasta"
      : "Download Concluído";

  return (
    <Dialog
      isOpen
      onOpenChange={(open) => {
        // Durante o download o modal não fecha por Esc/backdrop
        if (!open && !isDownloading) onClose();
      }}
      width={440}
    >
      <Stack gap={3}>
        <DialogHeader
          title={title}
          hasDivider
          {...(!isDownloading
            ? {
                onOpenChange: (open) => {
                  if (!open) onClose();
                },
              }
            : {})}
        />
        {error ? (
          <>
            <Banner status="error" title={error} />
            <HStack gap={2} hAlign="end">
              <Button label="Fechar" variant="primary" onClick={onClose} />
            </HStack>
          </>
        ) : isDownloading ? (
          <>
            <Stack gap={1}>
              <Text size="sm">
                Preparando download de: <strong>{folderName}</strong>
              </Text>
              {currentFile && (
                <Text type="supporting">Arquivo atual: {currentFile}</Text>
              )}
            </Stack>
            <ProgressBar
              label="Progresso do download"
              value={Math.min(progress, 100)}
              max={100}
              hasValueLabel
            />
            {isCancelling ? (
              <Text type="supporting" justify="center">
                Cancelando...
              </Text>
            ) : (
              <HStack gap={2} hAlign="end">
                <Button label="Cancelar" variant="ghost" onClick={handleCancel} />
              </HStack>
            )}
          </>
        ) : (
          <>
            <Banner
              status="success"
              title="Download concluído com sucesso!"
              description="O arquivo ZIP foi baixado para sua pasta de downloads."
            />
            <HStack gap={2} hAlign="end">
              <Button label="Fechar" variant="primary" onClick={onClose} />
            </HStack>
          </>
        )}
      </Stack>
    </Dialog>
  );
}
